import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faUserCog,
  faGripHorizontal,
  faSearch,
  faTimes,
} from '@fortawesome/free-solid-svg-icons'

import {
  faQuestionCircle,
  faUser,
} from '@fortawesome/free-regular-svg-icons'

library.add(
  faQuestionCircle,
  faUserCog,
  faGripHorizontal,
  faUser,
  faSearch,
  faTimes,
)
